import { render, staticRenderFns } from "./ren-dept-tree.vue?vue&type=template&id=18fce008"
import script from "./ren-dept-tree.vue?vue&type=script&lang=js"
export * from "./ren-dept-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports